import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import Btn from "../../CommonElements/Button";
import { H3 } from "../../../AbstractElements";

/**
 * Project base component modal. you only have to pass the children for contanct and props for config settings
 * @param {*} param0
 * @returns
 */
export default function BaseModal({
  show,
  modalTogle,
  children,
  size = "md",
  centered = true,
  modalHeader,
}) {
  return (
    <Modal
      isOpen={show}
      toggle={modalTogle}
      className="rounded-3"
      size={size}
      centered={centered}
    >
      {modalHeader}
      <ModalBody
        className="rounded-bottom p-0"
        style={{ backgroundColor: "#f5f5f5" }}
      >
        {children}
      </ModalBody>
    </Modal>
  );
}
